import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

// US-6.1 GET /api/v1/Framework returns ApiBaseResponse<IEnumerable<FrameworkResponse>>
// i.e. { data: [...], isSuccess: true } - a flat array, not a paged list.
export const getFramework = createAsyncThunk(
  "Framework/get",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL.FRAMEWORK.SLUG}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createFramework = createAsyncThunk(
  "Framework/create",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${API_URL.FRAMEWORK.SLUG}`, payload);
      dispatch(getFramework());
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editFramework = createAsyncThunk(
  "Framework/put",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${API_URL.FRAMEWORK.SLUG}`, payload);
      dispatch(getFramework());
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteFramework = createAsyncThunk(
  "Framework/delete",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.delete(`${API_URL.FRAMEWORK.SLUG}/${id}`);
      dispatch(getFramework());
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const frameworkSlice = createSlice({
  name: "framework",
  initialState: {
    framework_list: [],
    current_values: null,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFramework.fulfilled, (state, action) => {
      state.framework_list = action.payload?.data || [];
    });
  },
});

export const { setCurrentValues } = frameworkSlice.actions;
export default frameworkSlice.reducer;
